export default angular.module("modules:admin", ["modules"]).name;

require("./email");
require("./permission");
require("./permission-manager");
